var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('img',{attrs:{"src":"https://cdn.mos.cms.futurecdn.net/8SyJjYXNUcvnfLm4vamuGn-1024-80.jpg.webp"}}),_c('img',{attrs:{"src":"https://images-na.ssl-images-amazon.com/images/I/51Dg7PFL3mL._AC_SY355_.jpg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }